import Vue from 'vue'
import Vuex from 'vuex'

import state from './state'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'

// Modules
import appointments from './appointments'
import auth from './auth'
import inventories from './inventories'
import locations from './locations'
import medicalHistory from './medicalHistory'
import pets from './pets'
import providers from './providers'
import roles from './roles'
import stock from './stock'
import users from './users'
import vaccination from './vaccination'
import species from './species'

Vue.use(Vuex)

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules: {
    appointments,
    auth,
    inventories,
    locations,
    medicalHistory,
    pets,
    providers,
    roles,
    stock,
    users,
    vaccination,
    species
  },
  strict: false
})
